import { makePermissionsConfigGetter } from '@platform/front-core';
import {
    getAccountPermissionsConfig as getAccountPermissionsConfigCore,
    PermissionEntities,
    Permissions,
} from '@platform/ics-front-core';

export const getAccountPermissionsConfig = makePermissionsConfigGetter(
    (entities: PermissionEntities, permissions: Permissions) => {
        return {
            ...getAccountPermissionsConfigCore(entities, permissions),
            viewProfile: () => ({ isWithoutCheck: true }),
        };
    },
);
